<template>
  <div>
    <div class="banner">
      <div class="banner-content">
        <img class="img-fluid" src="../assets/images/banner/health_banner.jpg" alt="banner" />
        <div class="banner-text">
          <h1>衛生教育專區</h1>
          <div class="banner-text-line"></div>
          <span>Health Education</span>
        </div>
      </div>
    </div>
    <div class="pdf" v-if="MediaType == 'pdf'">
      <div class="top">
        <h2 v-if="Media.Number">{{Media.Number}}</h2>
        <div class="title">
          <span class="back" @click="back">◀</span>
          <span class="name">{{Media.Title}}</span>
          <span class="date">{{$moment(Media.PublishOn).format("YYYY-MM-DD")}}</span>
        </div>
      </div>
      <div id="mybook" v-if="showStyle"></div>
      <!-- <iframe
        :src="`https://docs.google.com/viewer?url=${Media.DocumentFile}&embedded=true`"
        width="100%"
        height="calc(100vh - 75px)"
        style="width: 100%; height: calc(100vh - 75px);"
        frameborder="0"
        scrolling="yes"
        v-if="!showStyle"
      ></iframe>-->
      <iframe
        :src="`https://docs.google.com/viewer?url=https://www.cwb.gov.tw/Data/fcst_pdf/W01.pdf&embedded=true`"
        width="100%"
        height="calc(100vh - 75px)"
        style="width: 100%; height: calc(100vh - 75px);"
        frameborder="0"
        scrolling="yes"
        v-if="!showStyle"
      ></iframe>
    </div>
    <div class="contentContainer-noMove" :style="{backgroundImage: 'url(' + BG + ')' }">
      <div class="content">
        <div class="content-title">
          <h2>{{$moment(Media.PublishOn).format("YYYY/MM/DD")}}-{{Media.Title}}</h2>
          <div class="bread">
            <router-link to="/">
              <i class="fas fa-home fa-lg"></i>
            </router-link>
            <span>></span>
            衛生教育專區
          </div>
        </div>
      </div>
      <div class="video_container container" v-if="MediaType == 'video'">
        <div class="video_box">
          <div
            class="date"
            v-if="Media.PublishOn"
          >刊登日期 : {{$moment(Media.PublishOn).format("YYYY-MM-DD")}}</div>
          <!-- <div class="title">{{Media.Title}}</div> -->
          <div class="video">
            <video
            v-if="!isYoutube"
              :src="Media.VideoUrl"
              :poster="Media.Image"
              controls="controls"
              preload
              :controlslist="'nodownload'"
            ></video>
            <div v-if="isYoutube" class="video-container">
                <iframe
                    width="560"
                    height="315"
                    :src="videoUrl"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                ></iframe>
        </div>
          </div>
          <div class="remark">{{Media.Introduction}}</div>
          <div class="download">
            <div class="btn blue-btn" v-if="!isYoutube">
              <a
                class
                :class="{'islogin':islogin}"
                href="javascript:;"
                @click="download(Media.VideoUrl)"
              >下載檔案</a>
            </div>
            <div class="contact-back">
              <router-link to="/healthEducation">
                回列表頁
                <img src="../assets/images/icon/back_icon.png" alt="回首頁" />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import healthApi from '@/assets/api/healthEducation';
import MagazineApi from '@/assets/api/magazine';
import BG from '../assets/images/index_bg_big.png';
// import $ from 'jquery';
// import wowBook from '../../public/plugins/wow_book/wow_book.min.js';
/* eslint-disable no-undef */
export default {
  name: 'conferencedetail',
  components: {},
  props: {
    islogin: {
      type: Boolean,
    },
    isallow: {
      type: Boolean,
    },
  },
  data() {
    return {
      BG,
      breadcrumbs: [
        {
          url: '/',
          title: '首頁',
        },
        {
          title: '會刊及影音',
        },
        {
          url: '/Conference/Healths',
          title: '衛教資訊',
        },
      ],
      // Type: window.location.pathname.split('/')[2],
      Location: window.location.hostname,
      Urlparams: '',
      showStyle: true,
      MediaType: '', // pdf or video
      Media: {},
      videoUrl: '',
      isYoutube: false,
    };
  },
  methods: {
    getVideoUrl(url) {
      const vm = this;
      if (url && url.indexOf('youtu') !== -1) {
        vm.isYoutube = true;
        const tmpUrl = url.replace('https://youtu.be/', '');
        vm.videoUrl = `https://www.youtube-nocookie.com/embed/${tmpUrl}`;
      }
    },
    back() {
      const vm = this;
      if (vm.$route.path.indexOf('health') !== -1) {
        vm.$router.push('/healthEducation');
      } else if (vm.$route.path.indexOf('magazine') !== -1) {
        vm.$router.push('/magazine');
      }
    },
    createpdf(path) {
      const vm = this;
      const windowWidth = $('body').width();
      if (windowWidth > 767) {
        vm.$nextTick(() => {
          $('#mybook').wowBook({
            container: window,
            width: 1200,
            maxHeight: 550,
            pageNumbers: false,
            toolbar: vm.islogin
              ? 'lastLeft, left,currentPage, right, lastRight, zoomin, zoomout, slideshow, fullscreen, thumbnails,share ,download'
              : 'lastLeft, left,currentPage, right, lastRight, zoomin, zoomout, slideshow, fullscreen, thumbnails,share',
            pdf: path,
          });
        });
      } else {
        vm.showStyle = false;
      }
    },
    downloadFunction(url, params = {}) {
      const uA = window.navigator.userAgent;
      const isIE = /msie\s|trident\/|edge\//i.test(uA)
        && !!(
          'uniqueID' in document
          || 'documentMode' in document
          || 'ActiveXObject' in window
          || 'MSInputMethodContext' in window
        );

      let Type;
      if (params.type === 'paf' || params.type === 'PDF') {
        Type = 'application/pdf';
      } else if (params.type === 'doc') {
        Type = 'application/msword';
      } else {
        Type = `video/${params.type}`;
      }
      this.$http
        .get(url, { responseType: 'blob' })
        .then(({ data }) => {
          const blob = new Blob([data], { type: Type });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `TADHfile.${params.type}`;

          if (isIE) {
            navigator.msSaveBlob(new Blob([data]), `TADHfile.${params.type}`);
          } else {
            link.click();
          }
        })
        .catch((err) => {
          // console.log('錯誤', err);
        });
      return true;
    },
    // eslint-disable-next-line consistent-return
    download(url) {
      const vm = this;
      // if (!vm.islogin) {
      //   return false;
      // }
      const Type = url.split('/').pop().split('.').pop();
      vm.downloadFunction(url, { type: Type });
    },
    getDetail(id) {
      const vm = this;
      if (vm.$route.path.indexOf('healthEducation') !== -1) {
        healthApi.getOne(id).then((res) => {
          if (res.status === 200) {
            if (vm.$route.params.documentID) {
              vm.Media = res.data.Data;
              vm.createpdf(vm.Media.DocumentFile);
              // vm.createpdf('http://localhost:8080/static/c988d0f17d3443d9aa7c8dd93f3322a1.pdf');
              vm.Urlparams = vm.$route.params.documentID;
              vm.MediaType = 'pdf';
            } else {
              vm.Media = res.data.Data;
              vm.Urlparams = vm.$route.params.videoID;
              vm.MediaType = 'video';
              vm.getVideoUrl(vm.Media.VideoUrl);
            }
          }
        });
      } else if (vm.$route.path.indexOf('magazine') !== -1) {
        MagazineApi.getMagazineDetail(id).then((res) => {
          if (res.status === 200) {
            vm.Media = res.data.Data;
            vm.createpdf(vm.Media.DocumentFile);
            vm.Urlparams = vm.$route.params.documentID;
            vm.MediaType = 'pdf';
          }
        });
      }
    },
  },
  created() {
    const vm = this;
    if (vm.$route.params.videoID) {
      vm.getDetail(vm.$route.params.videoID);
    } else {
      vm.getDetail(vm.$route.params.documentID);
    }

    if (vm.$route.params.videoID || vm.$route.params.documentID) {
      if (vm.$route.params.videoID) {
        vm.Urlparams = vm.$route.params.videoID;
        vm.MediaType = 'video';
        vm.getVideoUrl(vm.Media.VideoUrl);
      } else if (vm.$route.params.documentID) {
        vm.Urlparams = vm.$route.params.documentID;
        vm.MediaType = 'pdf';
      }
    }
  },
  mounted() {
  },
  watch: {},
  computed: {
    fromPath() {
      return this.$store.getters.from;
    },
  },
};
</script>

<style lang="scss">
  .wowbook-book-container {
    background-color: #fff;
  }
</style>
